import 'reflect-metadata';
import {jsonObject, jsonMember} from 'typedjson';

@jsonObject
export class CertificateIssuerDetails {

  @jsonMember({name: 'commonName'})
  public CommonName: string = '';

  @jsonMember({name: 'email'})
  public Email: string = '';

  @jsonMember({name: 'organization'})
  public Organization: string = '';

  @jsonMember({name: 'organizationalUnit'})
  public OrganizationalUnit: string = '';

  @jsonMember({name: 'locality'})
  public Locality: string = '';

  @jsonMember({name: 'state'})
  public State: string = '';

  @jsonMember({name: 'country'})
  public Country: string = '';
}
